import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { Link } from 'gatsby';
import React from 'react';

type Props = {
  title: string;
  link: string;
  className?: string;
}

const MenuItem: React.FC<Props> = (props) => {
  const linkElement = props.link.includes('https://') 
    ? (<OutboundLink href={props.link} target='blank'>{props.title}</OutboundLink>)
    : (<Link to={props.link}>{props.title}</Link>);

  return (
    <div className={`text-secondary hidden lg:block mr-12 ${props.className}`}>
      {linkElement}
    </div>
  )
};

export default MenuItem;

